module.exports = __webpack_public_path__ + "static/media/css.81c67ade.png";